// extracted by mini-css-extract-plugin
export default {"project":"WorkSection_project__mwRdt","desc":"WorkSection_desc__gX-OG"};